export default {
  DISABLE_CHANNELS_PUBLICATION: false
}
